var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-message-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        class: [
          "el-message",
          _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
          _vm.center ? "is-center" : "",
          _vm.showClose ? "is-closable" : "",
          _vm.customClass
        ],
        attrs: { role: "alert" },
        on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
      },
      [
        _vm.iconClass
          ? _c("i", { class: _vm.iconClass })
          : _c("i", { class: _vm.typeClass }),
        _vm._v(" "),
        _vm._t("default", [
          !_vm.dangerouslyUseHTMLString
            ? _c("p", { staticClass: "el-message__content" }, [
                _vm._v(_vm._s(_vm.message))
              ])
            : _c("p", {
                staticClass: "el-message__content",
                domProps: { innerHTML: _vm._s(_vm.message) }
              })
        ]),
        _vm._v(" "),
        _vm.showClose
          ? _c("i", {
              staticClass: "el-message__closeBtn uk-icon-close",
              on: { click: _vm.close }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-455b9f60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-455b9f60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./packages/message/src/main.vue
// module id = 383
// module chunks = 0